//// Accordian
(function($, window, undefined) {

  var defaults = {}
  
  function acToggle(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  acToggle.prototype = {
    init: function() {      
      var _this = this
      this.content = this.element.find('.js-ac-toggle-content'),
   
      //bind handlers
      this.element.on('click', function(e) {
        if (_this.element.hasClass('is-open')){
          _this.element.removeClass('is-open')
          _this.content.slideUp(200)
        } else {
          _this.element.addClass('is-open')
          _this.content.slideDown(200)
        }
      })   
    },
    
    closeAll:function(){
    },
  }

  $.fn.acToggle = function(settings) {
    return this.each(function () {
      $.data(this, 'acToggle', new acToggle(this, settings))
    })
  }

}(jQuery, window));